export default __webpack_public_path__ + "static/data-ace3fe6e3b116c7fc9a3bcac550776a1.png";